import React from 'react';

const CampaignTeaser = ({ entity }) => {

  return (
    <>Teaser Component</>
  );
};

export default CampaignTeaser;
